import React from 'react'
import ExploreComponent from '../Explore/Explore'

function Explore() {
  return (
    <>
        <ExploreComponent />
    </>
  )
}

export default Explore
